import { LoginTypes } from '../enums/login-types.enum';

export interface ResetPasswordRequest {
  employeeId?: number;
  emailAddress: string;
  loginType?: LoginTypes;
}
